import React, { useState, useEffect, useRef } from 'react';
 
import useTableFijo from "../useTableFijo";

import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import axios from 'axios';
import moment from 'moment';

import { IncluirAunmentoFondoAvance } from './modalAgregarAsignarFA';
import { formatMoneda } from '../../util/varios';

const TablaAsignacionFondoAvance = (props) => {

    var op = require('../../../src/modulos/datos')
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));
    const txtMonto1 = useRef();
    const headCells = [
        { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Código', textAlign: 'center' },
        { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'N° Fondo', textAlign: 'center' },
        { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Descripción', textAlign: 'center' },
        { id: '4', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' Fecha', textAlign: 'center' },
        { id: '5', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' Monto del Aumento ', textAlign: 'center' },

    ]


    const [values, setValues] = useState({
        idcuenta: "",
        auxiliar: "",
        descripcionaux: "",
        idcategoriaprogramatica: "",
        idpuc: "",
        puc: "",
        categoria: "",
        disponibilidad: 0.00,
        montoinicial: 0.00,
        tipopartida: "",

    });
    const [mostrar2, setMostrar2] = useState(false);
    const [mostrar, setMostrar] = useState(false);

    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [operacion, setOperacion] = useState(0);
    const [aprob, setAprob] = useState(null);
    const [aprobaciones, setAprobaciones] = useState();
    const [aprodetalle, setAprodetalle] = useState();
    const [norden, setNorden] = useState(true);
    const txtBuscador = useRef()
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const [deshabilitado, setDeshabilitado] = useState(false);

    const {
        TblContainer,
        TblHead,
        recordsAfterPagingAndSorting,
        TblPagination
    } = useTableFijo(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;
        setFilterFn({
            fn: items => {
                if (target.value === "")
                    return items;
                else
                    return items.filter(x => {

                        if (x.idaumentofondoavance.includes(target.value)
                            || x.idcompromiso.includes(target.value)
                            || x.razonsocial.includes(target.value)
                            || moment.utc(x.fecha).format('DD/MM/YYYY').toLowerCase().includes(target.value.toLowerCase())
                        ) {
                            return x;
                        }
                    });
            }
        })

    }

    const opciones = (ope, index) => (event) => {

        event.preventDefault();
        setOperacion(ope);

        if (ope !== 1) {
            if(values === ''){
                setMensaje({ mostrar: true, titulo: 'Debe seleccionar un item', texto: '', icono: '' })

            } else{
                setMostrar(true);

            }

        } else {
            setMostrar(true);

        }

    }

    const seleccionarFila = (item) => (e) => {
        e.preventDefault();
        setValues(item);
    };



    const handleCloseSi = () => {

        setActivate(false);

    };



    useEffect(() => {
        if(props.asignacion){
            setRecords(props.asignacion)
            txtMonto1.current.value = formatMoneda(props.asignacion.reduce((total, record) => total + parseFloat(record.monto), 0).toString().replace(',', '').replace('.', ','), ',', '.', 2)

        }
    }, [props.asignacion]);

   

    return (
        <div>
            <div className='col-md-12 mx-auto row px-0 '>
                <div className='col-md-11 row mx-auto'>
                    <TblContainer container={{ height: 300, width: '100%', overflow: 'auto', padding: '2px' }}>
                        <TblHead />

                        <tbody>
                            {

                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={item + item.idaumentofondoavance} className="table-bordered"  disabled={operacion === 1 || operacion === 2 ? false : true} style={{ padding: "0", cursor: 'pointer', background: values && values.idaumentofondoavance === item.idaumentofondoavance ? "lightskyblue" : "white" }} onClick={seleccionarFila(item)}>
                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{item.idaumentofondoavance}</td>
                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{item.nrofondo}</td>
                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{item.descripcion}</td>
                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{moment.utc(item.fechareal).format('DD/MM/YYYY')}</td>
                                        <td style={{ fontSize: "10px", textAlign: "right"}}>{ formatMoneda(item.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2) }</td>


                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    <div className='col-md-7'></div>
                    <div className="input-group input-group-sm col-md-5 mb-1" >
                        <label className="input-group-text bg-transparent border-0 fw-bold" id="inputGroup-sizing-sm"> Total Aporte: </label>
                        <input type="text" ref={txtMonto1} className="form-control  bg-transparent border-0 text-right" disabled={true} placeholder="0,00" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputDireccion" />
                    </div>
                </div>
                <div className='col-md-1 m-auto mb-1'>

                    <div className="col-md-12 my-2">
                        <button onClick={opciones(1, '')} disabled={ props.operacion === 2 ? false : true } className="btn btn-primary btn-sm rounded-pill"><i className="fas fa-plus"></i> </button>
                    </div>

                    <div className="col-md-12 my-2">
                        <button onClick={opciones(2, '')} disabled={ props.operacion === 2 ? false : true } className="btn btn-warning btn-sm rounded-pill"><i className="fas fa-edit" ></i> </button>
                    </div>
                    <div className="col-md-12 my-2">
                        <button onClick={opciones(3, '')} disabled={ props.operacion === 2 ? false : true } className="btn btn-danger btn-sm rounded-pill"><i className="fa fa-trash-alt"></i> </button>
                    </div>

                </div>
            </div>

            <IncluirAunmentoFondoAvance
                show={mostrar}
                onHideCancela={() => { setMostrar(false) , setValues() }}
                values={values}
                operacion={operacion}
                idfondo={props.idfondo}
                renderAsig={props.renderAsig}
            />

            <Mensaje mensaje={mensaje}
                onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
            
<Dimmer active={activate} inverted>
       
      </Dimmer>
        </div>
    );
}
export default TablaAsignacionFondoAvance;